@if (secondaryNavData$ | async; as navData) {
  @if (showSubNav && navData.categories?.length) {
    <dsa-subnav (ctaClick)="handleCtaClick($event)" [data]="navData" class="fss-secondary-nav"></dsa-subnav>
  }
}
